var _linearGradient, _linearGradient2, _linearGradient3, _circle, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgV8Liftoff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "6.5 .4 187 187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "45.3%",
    x2: "94.5%",
    y1: "23.1%",
    y2: "68.2%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5180d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#477fdf"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: "28.3%",
    y1: "62.1%",
    y2: "62.1%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#f4f4f4"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: "28.3%",
    y1: "62.1%",
    y2: "62.1%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ededed"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 67,
    fill: "#558dee"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M81.7 164.5a55.3 55.3 0 01-.6-4l2-107.7 35.6-17.2 2.1.7 45.7 71.7a67 67 0 01-66.5 59 67 67 0 01-18.3-2.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#434343",
    d: "M98 16v156H8l17-24h51V31.5L98 16zm4 0v156h90l-17-24h-51V31.5L102 16z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#b0b0b0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 138h44v10H25l7-10zm136 0l7 10h-51v-10h44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M85.4 69c-6.6 25-11 38.4-13.2 40-3.2 2.3-30.8 23.5-30.8 23.5L40 145l46 8 6-19h8V69H85.4zm29.2 0c6.6 25 11 38.4 13.2 40 3.2 2.3 30.8 23.5 30.8 23.5L160 145l-46 8-6-19h-8V69h14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e2e2e2",
    d: "M88.5 145l-2.5 8-46-8h48.5zm23 0l2.5 8 46-8h-48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M82.7 57.6C86.7 30.8 97 26 100 26v117H78.3c-1-39.5.4-58.6 4.4-85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f3f3f3",
    d: "M117.3 57.6C113.3 30.8 103 26 100 26v117h21.7c1-39.5-.4-58.6-4.4-85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d8d8d8",
    stroke: "#979797",
    d: "M98.5 128.5h3v35h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 143h4v14h-4zm24 0h4v14h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bababa",
    d: "M84 143h4v14h-4zm24 0h4v14h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 143h4v14h-4zm24 0h4v14h-4z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9f9f9f",
    d: "M92 143h4v14h-4zm24 0h4v14h-4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88 55a12 12 0 0124 0c0-4.4-5.4-8-12-8s-12 3.6-12 8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M100 143H88V55c0-4.4 5.4-8 12-8v96z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M112 143h-12V55c0-4.4 5.4-8 12-8v96z",
    transform: "matrix(-1 0 0 1 212 0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa",
    d: "M100 118c1.3 0 2 7.3 2 22v23h-4v-23c0-14.7.7-22 2-22z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgV8Liftoff);
export default __webpack_public_path__ + "static/media/v8-liftoff.7f242275a9d90183799a60e2ac56b166.svg";
export { ForwardRef as ReactComponent };